import { useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";

// Supplément broderie global (ajouté automatiquement au prix quand un nom est brodé). Ralph 30-09 : 15 $.
export function EmbroideryFeeSetting({ value, onSaved }) {
  const [fee, setFee] = useState(value ?? 15);
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try { const r = await api.put("/equipment-catalog/settings", { embroidery_fee: Number(fee) }); toast.success(`Supplément broderie : ${Number(r.data.boutique_settings.embroidery_fee).toFixed(2)} $`); onSaved?.(r.data.boutique_settings); }
    catch (e) { toast.error(e?.response?.data?.detail || "Erreur"); } finally { setBusy(false); }
  };
  return (
    <div className="flex flex-wrap items-center gap-2 rounded border border-zinc-800 bg-zinc-950/60 px-3 py-2 text-xs" data-testid="embroidery-fee-setting">
      <span className="text-zinc-300">🧵 Supplément broderie (nom brodé) :</span>
      <input type="number" step="0.5" min="0" max="200" value={fee} onChange={(e) => setFee(e.target.value)} className="w-20 bg-zinc-900 border border-zinc-700 rounded px-2 py-1 text-zinc-100" data-testid="embroidery-fee-input" />
      <span className="text-zinc-500">$ + taxes · ajouté automatiquement au prix membre quand un nom est brodé (kimono noir, gi noir & or, shorts officiels…)</span>
      <button onClick={save} disabled={busy} className="ml-auto px-3 py-1 rounded bg-amber-500 text-zinc-950 font-semibold disabled:opacity-40" data-testid="embroidery-fee-save">{busy ? "…" : "Enregistrer"}</button>
    </div>
  );
}
